import {ChatBase} from "@core/base/chat-base";
import {ChatActionBase} from "@core/base/chat-action-base";
import {ChatSettingBase} from "@core/base/chat-setting-base";
import {SessionBase} from "@core/base/session-base";
import { SubscriptionBase } from "@core/base/subscription-base";
import { ChatUtilsService } from "@core/shared/chat-utils.service";
import { OfficeBase } from "@core/base/office-base";

export abstract class CoreBase {
    abstract chat: ChatBase
    abstract chatAction: ChatActionBase
    abstract chatSetting: ChatSettingBase
    abstract chatUtils: ChatUtilsService
    abstract session: SessionBase
    abstract subscription: SubscriptionBase
    abstract office: OfficeBase
}
